import React from 'react';
import Link from 'gatsby-link';
import Img from 'gatsby-image';
import moment from 'moment';
import Helmet from 'react-helmet';
import { htmlToReact, stripTags } from '../helpers';
import {
  PageSection,
  Grid,
  Card,
  CardImage,
  CardSection,
  Row,
  Col,
  Icon,
  Image,
  CardDescription,
  Banner,
} from '../components';
import Layout from '../layouts/layout';

import eventPlaceholder from '../assets/img/event-placeholder.jpg';

/* const coursesDescription = (
  <PageSection>
    <Grid>
      <Row>
        <Col xs={12} md={6}>
          <h2 className="text-color-brick">Skupinové hodiny</h2>
          <p>
            Pohyb je ako ľudská reč. Deti začínajú jednoduchými hláskami, ktoré
            sa po niekoľkých rokoch menia na rozvité súvetia. Podobným procesom
            prechádzate aj v oblasti pohybu. Cieľom hodiny je harmonický rozvoj,
            rozšírenie pohybovej zásoby a posun začiatočníka na pokročilého
            neustále v inej pohybovej sfére. To privádza trénujúceho k
            porozumeniu konceptov výuky. Pestrá náplň hodín sa systematicky mení
            v závislosti od danej témy. Vhodné pre všetky fyzické úrovne.
          </p>
        </Col>
        <Col xs={12} md={6}>
          <h2 className="text-color-brick">Individuálne hodiny</h2>
          <p>
            Objavte umenie telesného rozvoja podľa vašich predstáv. Súkromné
            hodiny skvelá voľba pri zameraní na vami zvolený typ tréningu a
            naplnení osobných cieľov. Trénujúci sa učí hýbať novými sposobmi a
            zároveň prekonáva stále vačšie výzvy. Samotný proces rozvíja
            mentálnu stránku a buduje komplexnosť tela.
          </p>
        </Col>
      </Row>
    </Grid>
  </PageSection>
); */

const workshopsesDescriptionOg = `Movement je určený pre všetkých, ktorí majú radi pohyb bez ohľadu na
ich vek a fyzickú úroveň. Počas workshopu účastník spoznáva pohyb v jeho rôznych podobách.
Prostredníctvom rozličných hier a prekonávania náročných úloh
dosiahne rozvoj pohybových schopností a uvedomenie si podstaty
ľudského tela.`;

const workshopsesDescription = (
  <PageSection>
    <Grid>
      <Row>
        <Col xs={12} md={6}>
          {/* <h2 className="h2 text-weight-bold">WORKSHOP</h2> */}
          <div className="embed-container">
            <iframe
              src="https://www.youtube.com/embed/bon-5Bmvgr4"
              frameBorder="0"
              allowFullscreen
            />
          </div>
          {/* <p className="mb-xlarge">Workshop sa skladá zo 4 častí:</p> */}
        </Col>
        <Col xs={12} md={6}>
          {/* <h2 className="h2 text-weight-bold">WORKSHOP</h2> */}
          <p>
            <span className="text-color-brick">Workshopy</span> sú pre všetkých,
            ktorí majú radi pohyb bez ohľadu na ich vek a fyzickú úroveň. Počas
            workshopu účastník spoznáva pohyb v jeho rôznych podobách.
            Prostredníctvom rozličných hier a prekonávania náročných úloh
            dosiahne rozvoj pohybových schopností a uvedomenie si podstaty
            ľudského tela.
          </p>
          {/* <p className="mb-xlarge">Workshop sa skladá zo 4 častí:</p> */}
        </Col>
      </Row>
      {/*    <Row>
        <Col xs={12} md={6}>
          <p>
            <span className="text-weight-bold text-color-brick">AWARENESS</span>
            <br />
            Práca s gravitáciou a využitím momenta, kde sa zameriavame na
            zvýšenie telesného povedomia a udržania balansu v kritických
            polohách. Cieľom je dosiahnutie nezávislosti od vonkajších podnetov,
            vďaka čomu účastník nadobudne novú perspektívu pohybu.
            (Minimalistické cviky)
          </p>
          <p>
            <span className="text-weight-bold text-color-brick">
              EXPRESSION
            </span>
            <br />
            V tejto časti komunikujeme s telom pomocou improvizácie a práce s
            hudbou. Vnímame ich ako esenciálne nástroje k vyjadreniu našej
            vnútornej predstavivosti a jej stretom s realitou. (Voľnosť pohybu,
            prejav)
          </p>
        </Col>
        <Col xs={12} md={6}>
          <p>
            <span className="text-weight-bold text-color-brick">FLOORWORK</span>
            <br />
            Kotúle, stojky, lokomočné pohyby a ľahká akrobacia na podlahe, kde
            zámerom je dosiahnutie “slobody” v pohybe a nárast kontroly nad
            vlastným telom.
          </p>
          <p>
            <span className="text-weight-bold text-color-brick">PLAY</span>
            <br />
            Hra je neoddeliteľnou súčasťou každého živého stvorenia a zazrela
            svetlo sveta už dávno pred sformovaním ľudskej kultúry. Hravosť je
            založená na slobode rozhodovania, jednania a vedie ku kreativite
            človeka. (Pohybové hry, hry vo dvojiciach)
          </p>
        </Col>
      </Row> */}
    </Grid>
  </PageSection>
);

const NavLink = props => {
  if (!props.test) {
    return (
      <Link to={props.url}>
        <Icon name={props.iconName} className="mb-small" />
      </Link>
    );
  } else {
    return <span />;
  }
};

const EventsTemplate = ({ pageContext }) => {
  const { group, index, first, last, additionalContext } = pageContext;
  const previousUrl = index - 1 === 1 ? '' : (index - 1).toString();
  const nextUrl = (index + 1).toString();
  let futureGroup = [];
  let cardItems = [];
  let prevYear = 0;
  let count = 0;
  // eslint-disable-next-line
  group.map((edge, edgeIndex) => {
    if (!moment(edge.node.acf.date).isBefore())
      futureGroup.push(group[edgeIndex]);
  });

  /* eslint-disable */
  futureGroup.map(card => {
    const year = moment(card.node.acf.date)
      .locale('sk')
      .format('YYYY');
    if (year !== prevYear) {
      cardItems.push({
        year: year,
        items: [],
      });
      prevYear !== 0 ? count++ : count;
    }
    cardItems[count].items.push(card.node);
    prevYear = year;
  });
  /* eslint-enable */

  const renderDateRange = (group, rowIndex) => {
    const startDate = moment(group[0].node.acf.date)
      .locale('sk')
      .format(`DD.\u00A0MMMM\u00A0YYYY`);
    const endDate =
      group.length > 0
        ? `${moment(group[group.length - 1].node.acf.date)
            .locale('sk')
            .format('DD.\u00A0MMMM\u00A0YYYY')}`
        : '';
    const equal = startDate === endDate;
    if (rowIndex === 0) {
      return [
        <Col key="courses-name" xs={12} sm={rowIndex === 0 ? 4 : 12}>
          <h2>
            <strong>{additionalContext.name}</strong>
          </h2>
        </Col>,
        <Col
          key="date-range"
          xs={12}
          sm={rowIndex === 0 ? 4 : 12}
          className="text-center--s"
        >
          <h4 className="text-color-brick">
            {startDate}
            <br />
            {!equal && endDate}
          </h4>
        </Col>,
      ];
    }
  };

  const renderCards =
    futureGroup &&
    cardItems.map((row, rowIndex) => [
      <Row key="row-year">
        {renderDateRange(group, rowIndex)}
        <Col xs={12} sm={rowIndex === 0 ? 4 : 12} className="text-right--s">
          <h2>{row.year}</h2>
        </Col>
      </Row>,
      <Row key="row-cards" className="mb-small">
        {row.items.map((card, cardIndex) => (
          <Col key={cardIndex} xs={12} sm={6} md={4}>
            <Card
              href={`/${additionalContext.slug}/${card.slug}/`}
              data-aos="fade-up"
            >
              <CardImage>
                {card.featured_media ? (
                  <Img
                    fluid={{
                      ...card.featured_media.localFile.childImageSharp.small,
                    }}
                  />
                ) : (
                  <Image src={eventPlaceholder} isFluid />
                )}
              </CardImage>
              <CardSection
                date={moment(card.acf.date)
                  .locale('sk')
                  .format('DD. MMMM')}
                className="pt-xlarge"
              >
                <h3 className="h3">{htmlToReact(card.title)}</h3>
                <span className="card__time text-right">
                  {moment(card.acf.date)
                    .locale('sk')
                    .format('H:mm')}
                </span>
              </CardSection>
              <CardDescription
                href={`/${additionalContext.slug}/${card.slug}/`}
                content={{
                  content: htmlToReact(stripTags(card.content)),
                  date: moment(card.acf.date)
                    .locale('sk')
                    .format('DD. MMMM'),
                  time: moment(card.acf.date)
                    .locale('sk')
                    .format('H:mm'),
                }}
              />
            </Card>
          </Col>
        ))}
      </Row>,
    ]);

  return (
    <Layout type="transparent">
      <Helmet title={stripTags(`Adrian Bartalos | ${additionalContext.name}`)}>
        <meta property="og:image" content={additionalContext.banner} />
        <meta
          property="og:title"
          content={stripTags(`Adrian Bartalos | ${additionalContext.name}`)}
        />
        <meta
          property="og:description"
          content={
            additionalContext.slug === 'kurzy' ? '' : workshopsesDescriptionOg
          }
        />
      </Helmet>
      <Banner
        bgUrl={additionalContext.banner}
        svg={additionalContext.logo}
        fullWidth
        overlay
      />
      <PageSection type="beige" className="pt-xxlarge pt-s">
        <Grid>
          {renderCards.length !== 0 ? (
            renderCards
          ) : (
            <Row>
              <Col xs className="pb-xxlarge pt-xxlarge">
                <h3 className="text-center">
                  Momentálne nepriebiehajú žiadne{' '}
                  <span className="text-color-brick text-inherit">
                    {additionalContext.slug}
                  </span>
                </h3>
              </Col>
            </Row>
          )}
          <Row>
            <Col xs={12} className="d-flex align-items-justify">
              <NavLink
                test={first}
                url={`/${additionalContext.slug}/${previousUrl}`}
                iconName="left-arrow"
              />
              <NavLink
                test={last}
                url={`/${additionalContext.slug}/${nextUrl}`}
                iconName="right-arrow"
              />
            </Col>
          </Row>
        </Grid>
      </PageSection>
      {additionalContext.slug === 'kurzy' ? null : workshopsesDescription}
    </Layout>
  );
};

export default EventsTemplate;
